import React from 'react';
import { DataGrid } from '../../../common';
import StatusBadge from './StatusBadge';

const CateringGroupTable = ({ cateringGroups, loading }) => {
  const columns = [
    {
      field: 'groupIdentity',
      headerName: 'Group Identity',
      minWidth: 140,
      flex: 1,
      cellClass: 'hub-cell',
      sortable: true,
      cellRenderer: params => <span>{params.value}</span>,
    },
    {
      field: 'tailNumber',
      headerName: 'Tail Number',
      minWidth: 140,
      flex: 1,
      cellRenderer: params => (
        <div className="tail-cell">
          <a
            href={`/operations/aircraftMaster?tail=${params.value}`}
            className="tail-link"
          >
            {params.value}
          </a>
        </div>
      ),
    },
    {
      field: 'cateringGroupPath',
      headerName: 'Catering Group',
      minWidth: 220,
      flex: 1,
      cellRenderer: params => <span>{params.value}</span>,
    },
    {
      field: 'groupStatus',
      headerName: 'Group Status',
      minWidth: 180,
      flex: 1,
      sortable: true,
      cellRenderer: params => (
        <StatusBadge
          status={params.data?.groupStatus}
          label={params.data?.groupStatus}
        />
      ),
    },
  ];

  return (
    <DataGrid
      className="full-flex"
      columns={columns}
      rowData={cateringGroups}
      rowModelType="clientSide"
      showDefaultFilters={false}
      loading={loading}
      columnResize
      scrollbar
      pagination
      paginationPageSize={20}
      emptyMessage={
        <>
          {cateringGroups?.length === 0 && (
            <div className="empty-state">
              <h3 className="empty-title">No Catering Groups Found</h3>
              <p className="empty-desc">
                Try widening your search terms or selecting a different
                date/update.
              </p>
            </div>
          )}
        </>
      }
    />
  );
};

export default CateringGroupTable;
